import Request from '@/utils/request'

export function holidayActBaseInfo () {
  return Request({
    url: `/api/v2/app/activity/ny/home`,
    method: 'get'
  })
}

export function holidayActRank () {
  return Request({
    url: `/api/v2/app/activity/ny/rank`,
    method: 'get'
  })
}

export function holidayDaySign () {
  return Request({
    url: `/api/v2/app/activity/ny/daily/sign`,
    method: 'post'
  })
}

export function holidayDayClaim (taskId) {
  return Request({
    url: `/api/v2/app/activity/ny/daily/claim?taskId=${taskId}`,
    method: 'post'
  })
}

export function holidayMilesClaim () {
  return Request({
    url: `/api/v2/app/activity/ny/milestone/claim`,
    method: 'post'
  })
}
